import React from "react";

const UserMenuModal = ({ onClose, onProfile, onWishlist, onOrders, onLogout }) => {
  return (
    <div className="fixed inset-0 z-50 sm:mt-[100px] mt-[55px] mr-[15px] sm:mr-0" onClick={onClose}>
      <div className="absolute right-0 w-48 bg-white shadow-lg rounded-md border border-gray-200 font-poppins sm:mr-8 sm:-mt-8" onClick={(e) => e.stopPropagation()}>
      <ul className="flex flex-col py-2 text-sm text-gray-700">
        <li
          onClick={onProfile}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
        >
          Profile
        </li>
        <li
          onClick={onWishlist}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
        >
          My Wishlist
        </li>
        <li
          onClick={onOrders}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
        >
          My Orders
        </li>
        <li
          onClick={onLogout}
          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
        >
          Logout
        </li>
      </ul>
    </div>
    </div>
    
  );
};

export default UserMenuModal;